<template>
  <div class="filed-container">
    <div :class="['filed-main', { 'filed-main-edit': !disabled }]">
      <div class="filed-head">
        <van-nav-bar :title="info" :border="false" />
      </div>
      <div class="filed-checkCard">
           <van-field
                v-model="filedValue"
                :colon='true'
                :placeholder='getPlaceholder(info)'
                ref='filed'
                autosize
                type="textarea"
                rows="2"
                :disabled='disabled'
            />
      </div>
      <div v-if="!disabled" class="filed-footer">
        <div class="filed-footer-actions">
          <van-button
            block
            plain
            class="cancel-btn"
            @click="onCancal"
          >取消</van-button>
          <van-button
            block
            type="primary"
            class="save-btn"
            @click="onClickSave"
          >保存</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { updateUserInfo, getMatchmakerViewMemberInfo } from '../api/user';
import { Toast } from 'vant';
export default {
  data() {
    return { 
      value: "", // 英文
      info: "",  // 中文
      filedValue: '', // 值
      disabled: false
    };
  },
   computed: {
    ...mapGetters([
      'baseInfo'
    ]),
  },
  methods: {
    // 点击保存进行判断
    onClickSave(e) {
        if (this.disabled) {
          return;
        }
        if (!this.filedValue && this.value !== 'nickName') {
            Toast.fail(`${this.info}不能为空`);
            return;
        }
        if (this.value === 'contactNumber') {
          let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
          if (!reg_tel.test(this.filedValue)) {
            Toast.fail({message:'请输入正确的手机号',className:'phoneErrMessage'});
            return;
          }
        }
        let data = JSON.parse(JSON.stringify(this.baseInfo));
        data[this.value] =  this.filedValue;
        updateUserInfo(data).then(res => {
            if(res.code === 20000) {
                this.$store.dispatch('UpdateBasicInfo', res.data);
                Toast.success({message:'保存成功',className:'interestsErrMessage'});
                setTimeout(() => {
                    this.$router.go(-1);
                }, 300);
            }
            })
    },
    // 提示语
    getPlaceholder(value){
        return '请输入' + value;
    },
    onCancal() {
      this.$router.go(-1);
    },
    // 跟进英文获取对应的中文释义
    getBasicInfo(data) {
          const value = this.$route.params.name;
          this.filedValue = data[value];
          this.value = value;
          switch (value) {
            case "weight":
              this.info = "体重";
              break;
            case "nickName":
              this.info = "昵称";
              break;
            case "personalCharacterDescription":
              this.info = "性格描述";
              break;
            case "datingDeclaration":
              this.info = "自定义签名";
              break;
            case "descriptionOfSpouseSelectionRequirements":
              this.info = "择偶意向";
              break;
            case "tikTok":
              this.info = "抖音号";
              break;
            case "contactNumber":
              this.info = "联系电话";
              break;
            case "personalFamilyDescription":
              this.info = "家庭情况描述";
              break;
            case "positionTitle":
              this.info = "岗位名称";
              break;
            case "department":
              this.info = "所在部门";
              break;
            case "companyName":
              this.info = "公司名称";
              break;
            default:
              break;
          }
    }
  },
  
  mounted() {
    // 是否自动聚焦
    this.$refs.filed;
    if (!this.disabled) {
        this.$refs.filed.focus();
    }
  },
  created() {
    // 如果是查看则禁止点击,并从后台获取数据
    if (this.$route.name === 'lookFiled') {
        this.disabled = true;
        getMatchmakerViewMemberInfo(this.$route.params.id).then(res => {
              if (res.data) { 
                  let data =JSON.parse(JSON.stringify(res.data));
                  this.getBasicInfo(data);
              }
          })
    }
    // 如果是用户自己编辑则调用vuex数据
    if (this.$route.params.name && !this.disabled) {
        let data =JSON.parse(JSON.stringify(this.baseInfo));
        this.getBasicInfo(data);
    }
  },
};
</script>
<style scoped lang='less' src='../style/editFiled.less' />



// WEBPACK FOOTER //
// src/views/editFiled.vue